var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Widget',{ref:"widget",attrs:{"partnerId":_vm.partnerId,"theme":_vm.theme,"showFiat":_vm.showFiat,"showLatest":_vm.showLatest,"client":_vm.client},on:{"partnerLoaded":_vm.updateWidgetSize}})}
var staticRenderFns = []

export { render, staticRenderFns }